// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JWL4","footer":"styles_footer__1DjUX"};